import LandingPageCards from '@/app/components/LandingPage/LandingPageCards';

const PartnershipsCards = () => {
  return (
    <section className="mb-20 lg:py-10" data-cy="partnerships-cards">
      <LandingPageCards
        cards={[
          {
            description: {
              messageKey: 'partnerships_cards_deeper_copy',
            },
            id: 'deeper_insights',
            image: {
              localizedAlt: 'partnerships_deeper_insights_alt',
              src: 'blue-sky/partnerships/deeper-insights',
            },
            title: {
              messageKey: 'partnerships_cards_deeper',
            },
          },
          {
            description: {
              messageKey: 'partnerships_cards_personalized_copy',
            },
            id: 'personalized_experiences',
            image: {
              localizedAlt: 'stretch_hand_img_alt',
              src: 'partnerships/or4/overhead-stretch',
            },
            title: {
              messageKey: 'partnerships_cards_personalized',
            },
          },
          {
            description: {
              messageKey: 'partnerships_cards_daily_copy',
            },
            id: 'daily_engagement',
            image: {
              localizedAlt: 'partnerships_daily_engagement_alt',
              localizedSrc: 'partnerships_engage_img',
            },
            title: {
              messageKey: 'partnerships_cards_daily',
            },
          },
        ]}
      />
    </section>
  );
};

export default PartnershipsCards;
